import { PriorityBadge } from '@/components/ui/priority-badge'
import { StatusBadge } from '@/components/ui/status-badge'
import type { TaskResponse } from '@/types/task'

function getDueDateClass(dueDate: string | null): string {
  if (!dueDate) return 'text-muted-foreground'
  const today = new Date().toISOString().slice(0, 10)
  if (dueDate < today) return 'text-red-600 font-medium'
  if (dueDate === today) return 'text-orange-500 font-medium'
  return 'text-muted-foreground'
}

function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

interface TaskCardProps {
  task: TaskResponse
  onClick?: () => void
}

export function TaskCard({ task, onClick }: TaskCardProps) {
  return (
    <div
      onClick={onClick}
      className={`rounded-xl border border-border bg-card p-4 space-y-2 transition-colors ${onClick ? 'cursor-pointer hover:bg-secondary' : ''}`}
    >
      {/* Title */}
      <p className="text-sm font-medium leading-snug">{task.title}</p>

      {/* Badges row */}
      <div className="flex flex-wrap items-center gap-2">
        <StatusBadge name={task.status_name} color={task.status_color} />
        <PriorityBadge priority={task.priority} />
      </div>

      {/* Meta row: due date + assignee */}
      <div className="flex items-center justify-between gap-2">
        <span className={`text-xs ${getDueDateClass(task.due_date)}`}>
          {task.due_date ? formatDate(task.due_date) : 'Tanpa due date'}
        </span>

        {task.assignee_name ? (
          <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
            {task.assignee_avatar ? (
              <img
                src={task.assignee_avatar}
                alt={task.assignee_name}
                className="h-5 w-5 rounded-full object-cover"
              />
            ) : (
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-[10px] font-medium">
                {task.assignee_name.charAt(0).toUpperCase()}
              </span>
            )}
            {task.assignee_name}
          </span>
        ) : (
          <span className="text-xs text-muted-foreground">Tidak ada assignee</span>
        )}
      </div>
    </div>
  )
}
